import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setLoader, setSuccess } from "../../../actions/action-creators";
import SelectList from "../../global/form/select";
import UserDocuments from "./user_documents";
import UserProjects from "./user_projects";
import UserBankDetails from "./user_bank_details";
import UserReferrals from "./fetch_referrals";
import UserWalletDetails from "./user_wallet_details";
import UserPayouts from "./user_payouts";
import UserCallDetails from "./call_details";
import { TrackEvent } from "../../../actions/ga";
import ServicePurchase from "../reports/service_purchase";
import UserTickets from "./user_tickets";
import UserDetailsMyTeam from "./user_details_myteam";
import UserPortfolio from "./user_portfolio";
import UserBadgeHistory from "./user_badge_history";
import UserSaveGrow from "./user_save_grow";
import UserDeals from "./user_deals";
import CONSTANTS from "../../../constants/index";
import moment from "moment";

const CONSUMER_TYPES = [
    { value: 1, label: "Individual Partner" },
    { value: 2, label: "Shop Owner" },
    { value: 3, label: "Influencer" },
];

const CATEGORY_MAP = {
    1: "Merchant Account", 2: "Account Open", 3: "Loans", 4: "Demat Account",
    5: "Seller Account", 6: "Credit Cards", 12: "Insurance", 21: "Shopping",
    22: "Mutual Fund", 23: "Shopping",
};

const MENU_SECTIONS = [
    {
        label: "Core",
        items: [
            { label: "Overview", tab: 0 },
            { label: "KYC Details", tab: 9 },
            { label: "Projects", tab: 1 },
            { label: "Earnings", tab: 2 },
        ]
    },
    {
        label: "Save & Grow",
        items: [
            { label: "Save & Goal", tab: 3 },
            { label: "Deals", tab: 5 },
            { label: "Recharges & BBPS", tab: 6 },
        ]
    },
    {
        label: "Partner Intel",
        items: [
            { label: "Support", tab: 7 },
            { label: "Network", tab: 8 },
        ]
    }
];

class PartnerDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: { details: {} },
            selectedProfileTab: 0,
            activitySubTab: "calldata",
            myteamSubTab: "myteam",
            kycSubTab: "documents",
            earningsSubTab: "summary",
            overviewData: null,
            isShowBadgeHistory: false,
            isShowProfilePhoto: false,
            isMobile: typeof window !== "undefined" && window.innerWidth < 768,
        };
    }

    componentDidMount() {
        TrackEvent("PARTNER_PROFILE", "PARTNER_PROFILE_DATA_VIEW", "PARTNER_PROFILE_DATA");
        this.profileDetail();
        this.fetchOverviewData();
        this._onResize = () => this.setState({ isMobile: window.innerWidth < 768 });
        window.addEventListener("resize", this._onResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this._onResize);
    }

    profileDetail = async () => {
        store.dispatch(setLoader(true));
        try {
            var body = { user_id: this.props.user_id };
            let profileResp = await ApiEndpoints.UserProfile.fetchProfile(body);
            let profileDetail = profileResp.data.data;
            if (profileDetail.details.profile_picture_key) {
                let profileFileResp = await ApiEndpoints.Files.getFileID({ file_id: profileDetail.details.profile_picture_key });
                profileDetail.details.profile_picture_url = profileFileResp.data.data[0] ? profileFileResp.data.data[0].url : null;
            }
            this.setState({ userInfo: profileDetail });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    updateConsumerType = async (consumer_type) => {
        let { userInfo } = this.state;
        const previousValue = userInfo.details.consumer_type;
        if (previousValue === consumer_type) return;
        userInfo.details.consumer_type = consumer_type;
        this.setState({ userInfo });
        store.dispatch(setLoader(true));
        try {
            await ApiEndpoints.UserProfile.updateProfile({ user_id: this.props.user_id, consumer_type });
            store.dispatch(setSuccess({ show: true, message: "User Type Updated Successfully!" }));
        } catch (e) {
            userInfo.details.consumer_type = previousValue;
            this.setState({ userInfo });
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    fetchOverviewData = async () => {
        const uid = this.props.user_id;
        const [walletRes, projectsRes, referralsRes, teamRes, docsRes, bankRes, metaRes, goldRes, referredByRes, dealsSummaryRes, deviceInfoRes] = await Promise.allSettled([
            ApiEndpoints.Userwallet.fetchUserBalance({ user_id: uid }),
            ApiEndpoints.UserProfile.fetchUserActiveProjects({ user_id: uid }),
            ApiEndpoints.Referral.fetchReferralDetails({ referred_by: uid }),
            ApiEndpoints.MyTeamUserDetails.fetchCountDetails({ user_id: uid }),
            ApiEndpoints.UserProfile.fetchDocument({ user_id: uid, type: ["PAN", "AADHAAR"] }),
            ApiEndpoints.UserProfile.fetchBankDetails({ user_id: uid }),
            ApiEndpoints.User.fetchUserMetaData({ user_id: uid }),
            ApiEndpoints.SafeGold.fetchUserPortfolio({ user_id: uid }),
            ApiEndpoints.Referral.fetchReferralDetails({ used_by: uid }),
            ApiEndpoints.Deals.fetchUserSummary({ user_id: uid }),
            ApiEndpoints.UserProfile.fetchDeviceInfo({ user_id: uid }),
        ]);

        const wallet         = walletRes.status      === 'fulfilled' ? walletRes.value.data.data[0] || {} : null;
        const activeProjects = projectsRes.status    === 'fulfilled' ? (projectsRes.value.data.data || []).length : null;
        const referrals      = referralsRes.status   === 'fulfilled' ? (referralsRes.value.data.data || []) : null;
        const teamRaw        = teamRes.status        === 'fulfilled' ? teamRes.value.data.data[0] || {} : {};
        const teamCount      = teamRaw.ExternalUsers ? teamRaw.ExternalUsers.length : null;
        const documents      = docsRes.status        === 'fulfilled' ? docsRes.value.data.data || [] : [];
        const bankDetails    = bankRes.status        === 'fulfilled' ? bankRes.value.data.data || [] : [];
        const payoutMeta     = metaRes.status        === 'fulfilled' ? metaRes.value.data.data[0] || {} : {};
        const goldPortfolio  = goldRes.status        === 'fulfilled' ? goldRes.value.data.data || null : null;
        const referredByData = referredByRes.status  === 'fulfilled' ? referredByRes.value.data.data || [] : [];
        const referredByUser = referredByData.length ? referredByData[0].user : null;
        const dealsSummary   = dealsSummaryRes.status === 'fulfilled' ? dealsSummaryRes.value.data.data || {} : {};
        const cashbackAmount = Number(dealsSummary.PAYOUT) || 0;
        const deviceInfo     = deviceInfoRes.status  === 'fulfilled' ? deviceInfoRes.value.data.data[0] || {} : {};

        this.setState({
            overviewData: {
                wallet,
                activeProjects,
                referralCount: referrals ? referrals.length : null,
                teamCount,
                documents,
                bankDetails,
                payoutMeta,
                goldPortfolio,
                cashbackAmount,
                referredByUser,
                deviceInfo,
            }
        });
    };


    switchTab = (tab) => {
        this.setState({ selectedProfileTab: tab });
    };

    renderSubTabBar(tabs, active, onSelect) {
        return (
            <div style={S.subTabBar}>
                {tabs.map(t => (
                    <button
                        key={t.key}
                        style={{ ...S.subTabBtn, ...(active === t.key ? S.subTabBtnActive : {}) }}
                        onClick={() => onSelect(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>
        );
    }

    renderOverview() {
        let { userInfo, overviewData, isShowBadgeHistory, isShowProfilePhoto, isMobile } = this.state;

        if (isShowBadgeHistory) {
            return <UserBadgeHistory user_id={this.props.user_id} onBack={() => this.setState({ isShowBadgeHistory: false })} />;
        }
        let d = userInfo.details || {};
        let badgeConfig = d.badge_level >= 0 ? CONSTANTS.badgeConfig[d.badge_level] : null;
        let kycColor = d.kyc_status === 1 ? "#1a7a42" : d.kyc_status === 2 ? "#c0392b" : "#d46b08";
        let kycLabel = d.kyc_status === 1 ? "✓ KYC Verified" : d.kyc_status === 2 ? "✗ KYC Rejected" : "● KYC Pending";
        let initials = (userInfo.first_name || "?").charAt(0).toUpperCase();

        const fmtINR = (v) => v != null ? "₹" + Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2 }) : "—";
        const fmtDate = (iso) => iso ? moment(iso).utcOffset("+05:30").format("Do MMM'YY hh:mmA") : "—";

        // ── KPI values ────────────────────────────────────────────────────────
        const wallet = overviewData?.wallet;
        const { activeProjects, referralCount, teamCount, goldPortfolio, cashbackAmount, referredByUser, deviceInfo } = overviewData || {};

        const goldValue = goldPortfolio?.gold_balance != null
            ? Number(goldPortfolio.gold_balance).toFixed(4) + "g"
            : "—";

        const KPIS = [
            { label: "Total Earnings",  value: wallet ? fmtINR(wallet.earning_amount)  : "—", accent: "#27ae60" },
            { label: "Wallet Balance",  value: wallet ? fmtINR(wallet.total_amount)    : "—", accent: "#1677ff" },
            { label: "Active Projects", value: activeProjects != null ? activeProjects : "—", accent: "#1677ff" },
            { label: "Total Referrals", value: referralCount  != null ? referralCount  : "—", accent: null },
            { label: "Gold Holding",    value: goldValue,                                      accent: "#e8a020" },
            { label: "Deals Cashback",  value: cashbackAmount != null ? fmtINR(cashbackAmount) : "—", accent: null },
            { label: "Team Members",    value: teamCount      != null ? teamCount      : "—", accent: "#1677ff" },
        ];

        // ── Trust grid values ─────────────────────────────────────────────────
        const documents  = overviewData?.documents  || [];
        const payoutMeta = overviewData?.payoutMeta || {};

        const panDoc    = documents.find(doc => doc.type === 'PAN');
        const panStatus = !overviewData ? { label: "—", color: "#aaa" }
            : !panDoc    ? { label: "Not Uploaded", color: "#aaa" }
            : panDoc.status === 1 ? { label: "✓ PAN Verified", color: "#1a7a42" }
            : panDoc.status === 2 ? { label: "✗ PAN Rejected", color: "#c0392b" }
            : { label: "● Pending", color: "#d46b08" };

        const payoutStatus = !overviewData ? { label: "—", color: "#aaa" }
            : payoutMeta.payout_status === 2 ? { label: "● Payout On Hold", color: "#c0392b" }
            : payoutMeta.payout_status === 1 ? { label: "✓ Payout Active",  color: "#1a7a42" }
            : { label: "—", color: "#aaa" };

        const interestedCatId    = payoutMeta.interested_category;
        const interestedCatLabel = interestedCatId != null
            ? (CATEGORY_MAP[interestedCatId] || `Category #${interestedCatId}`)
            : "—";

        const TRUST_ROWS = [
            { label: "PAN Card",            ...panStatus },
            { label: "KYC",                 value: kycLabel, color: kycColor },
            { label: "Payout Status",       ...payoutStatus },
            { label: "Interested Category", value: interestedCatLabel, color: "#555" },
        ];

        return (
            <div>
                {/* A. Partner Identity Header */}
                <div style={S.identityCard}>
                    {/* Top row: avatar + name/contact + pills */}
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 16, width: "100%" }}>
                        {d.profile_picture_url ? (
                            isShowProfilePhoto ? (
                                <img
                                    src={d.profile_picture_url}
                                    alt="Profile"
                                    style={{ width: 60, height: 60, minWidth: 60, borderRadius: "50%", objectFit: "cover", cursor: "pointer" }}
                                    onClick={() => this.setState({ isShowProfilePhoto: false })}
                                />
                            ) : (
                                <div
                                    style={{ ...S.avatar, cursor: "pointer", fontSize: 20 }}
                                    title="Click to view photo"
                                    onClick={() => this.setState({ isShowProfilePhoto: true })}
                                >
                                    👁
                                </div>
                            )
                        ) : (
                            <div style={S.avatar}>{initials}</div>
                        )}
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={S.partnerName}>{userInfo.first_name || "—"}</div>
                            <div style={{ ...S.metaRow, ...(isMobile ? { flexDirection: "column", gap: 3, alignItems: "flex-start" } : {}) }}>
                                <span style={S.metaItem}>📋 PMW{userInfo.id}</span>
                                {userInfo.email && <span style={S.metaItem}>✉ {userInfo.email}</span>}
                                {d.whatsapp_no && <span style={S.metaItem}>📱 {"******" + d.whatsapp_no.toString().substr(-4)}</span>}
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 6, flexShrink: 0 }}>
                            {badgeConfig && (
                                <span
                                    style={{ ...S.pill, background: `${badgeConfig.secondaryColor}30`, color: badgeConfig.baseColor, border: `1px solid ${badgeConfig.secondaryColor}50`, cursor: "pointer" }}
                                    onClick={() => this.setState({ isShowBadgeHistory: true })}
                                >
                                    ⭐ {badgeConfig.name}
                                </span>
                            )}
                            <span style={{ ...S.pill, background: d.kyc_status === 1 ? "#e6f7ee" : "#fff0f0", color: kycColor }}>
                                {kycLabel}
                            </span>
                        </div>
                    </div>
                    {/* Footer row: always full-width below the top row */}
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(auto-fill, minmax(130px, 1fr))",
                        gap: 12,
                        paddingTop: 12,
                        borderTop: "1px solid #f0f0f0",
                        width: "100%",
                    }}>
                        <div style={S.footerItem}>
                            <span style={S.footerLabel}>User Type</span>
                            <SelectList
                                style={{ fontSize: 13, fontWeight: 500 }}
                                value={d.consumer_type || 1}
                                onChange={({ target }) => this.updateConsumerType(Number(target.value))}
                            >
                                {CONSUMER_TYPES.map(type => (
                                    <option key={type.value} value={type.value}>{type.label}</option>
                                ))}
                            </SelectList>
                        </div>
                        <div style={S.footerItem}>
                            <span style={S.footerLabel}>Referred By</span>
                            <span style={S.footerValue}>
                                {referredByUser ? `${referredByUser.first_name} (PMW${referredByUser.id})` : "—"}
                            </span>
                        </div>
                        {d.created_on && (
                            <div style={S.footerItem}>
                                <span style={S.footerLabel}>App Download</span>
                                <span style={S.footerValue}>{fmtDate(d.created_on)}</span>
                            </div>
                        )}
                        {d.uninstalled_on && (
                            <div style={S.footerItem}>
                                <span style={S.footerLabel}>Uninstalled On</span>
                                <span style={{ ...S.footerValue, color: "#c0392b" }}>{fmtDate(d.uninstalled_on)}</span>
                            </div>
                        )}
                        {d.dob && (
                            <div style={S.footerItem}>
                                <span style={S.footerLabel}>Date of Birth</span>
                                <span style={S.footerValue}>{moment(d.dob).utcOffset("+05:30").format("Do MMM YYYY")}</span>
                            </div>
                        )}
                        {(d.city || d.state) && (
                            <div style={S.footerItem}>
                                <span style={S.footerLabel}>Location</span>
                                <span style={S.footerValue}>
                                    {[d.city, d.state, d.zip_code].filter(Boolean).join(", ")}
                                </span>
                            </div>
                        )}
                        {d.permanent_address && (
                            <div style={{ ...S.footerItem, gridColumn: isMobile ? "span 2" : "auto" }}>
                                <span style={S.footerLabel}>Address</span>
                                <span style={S.footerValue}>{d.permanent_address}</span>
                            </div>
                        )}
                    </div>
                </div>

                {/* B. Quick KPIs */}
                <div style={S.ovSection}>
                    <div style={S.ovSectionTitle}>
                        Quick KPIs
                        <span style={S.ovSectionDivider} />
                    </div>
                    <div style={{ ...S.kpiRow, gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(auto-fill, minmax(140px, 1fr))" }}>
                        {KPIS.map((k, i) => (
                            <div key={i} style={{ ...S.kpiCard, borderLeftColor: k.accent || "#e0e0e0" }}>
                                <span style={S.kpiLabel}>{k.label}</span>
                                <div style={S.kpiValue}>{k.value}</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* C. Verification & Trust */}
                <div style={S.ovSection}>
                    <div style={S.ovSectionTitle}>
                        Verification &amp; Trust
                        <span style={S.ovSectionDivider} />
                    </div>
                    <div style={{ ...S.trustGrid, gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr" }}>
                        {TRUST_ROWS.map((t, i) => (
                            <div key={i} style={S.trustRow}>
                                <span style={S.trustLabel}>{t.label}</span>
                                <span style={{ ...S.trustValue, color: t.color }}>{t.value}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* D. Device Info */}
                <div style={S.ovSection}>
                    <div style={S.ovSectionTitle}>
                        Device Info
                        <span style={S.ovSectionDivider} />
                    </div>
                    <div style={{ ...S.trustGrid, gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr" }}>
                        {[
                            { label: "App Version", value: d.current_app_version || "—" },
                            { label: "Device",      value: deviceInfo?.manufacturer ? `${deviceInfo.manufacturer} ${deviceInfo.model_name || ""}`.trim() : "—" },
                            { label: "OS Version",  value: deviceInfo?.os_version || "—" },
                            { label: "Network",     value: deviceInfo?.network_carrier || "—" },
                            ...(deviceInfo?.is_blocked ? [{ label: "Device Status", value: "Blocked", color: "#c0392b" }] : []),
                        ].map((row, i) => (
                            <div key={i} style={S.trustRow}>
                                <span style={S.trustLabel}>{row.label}</span>
                                <span style={{ ...S.trustValue, color: row.color || "#333" }}>{row.value}</span>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        );
    }

    renderContent() {
        let { selectedProfileTab, userInfo, activitySubTab, myteamSubTab, kycSubTab, earningsSubTab } = this.state;

        switch (selectedProfileTab) {
            case 0:
                return this.renderOverview();

            case 1:
                return <UserProjects user_id={this.props.user_id} applicationData={this.props.application_data} />;

            case 2:
                return (
                    <div>
                        {this.renderSubTabBar(
                            [
                                { key: "summary",  label: "💰 Summary" },
                                { key: "projects", label: "📊 Project Earnings" },
                                { key: "payouts",  label: "💸 Payouts" },
                            ],
                            earningsSubTab,
                            (v) => this.setState({ earningsSubTab: v })
                        )}
                        {earningsSubTab !== "payouts" && (
                            <UserWalletDetails user_id={this.props.user_id} view={earningsSubTab} />
                        )}
                        {earningsSubTab === "payouts" && <UserPayouts user_id={this.props.user_id} />}
                    </div>
                );

            case 3:
                return <UserSaveGrow user_id={this.props.user_id} />;

            case 4:
                return <UserSaveGrow user_id={this.props.user_id} />;

            case 5:
                return <UserDeals user_id={this.props.user_id} />;

            case 6:
                return <ServicePurchase.ServicePurchase user_id={this.props.user_id} />;

            case 7:
                return (
                    <div>
                        {this.renderSubTabBar(
                            [{ key: "calldata", label: "📞 Call Data" }, { key: "tickets", label: "🎫 Tickets" }],
                            activitySubTab,
                            (v) => this.setState({ activitySubTab: v })
                        )}
                        {activitySubTab === "calldata" && <UserCallDetails user_id={this.props.user_id} userInfo={userInfo} />}
                        {activitySubTab === "tickets"  && <UserTickets user_id={this.props.user_id} />}
                    </div>
                );

            case 8:
                return (
                    <div>
                        {this.renderSubTabBar(
                            [{ key: "myteam", label: "👥 My Team" }, { key: "referrals", label: "🔗 Referrals" }, { key: "portfolio", label: "📍 Portfolio Mapping" }],
                            myteamSubTab,
                            (v) => this.setState({ myteamSubTab: v })
                        )}
                        {myteamSubTab === "myteam"    && <UserDetailsMyTeam user_id={this.props.user_id} />}
                        {myteamSubTab === "referrals" && <UserReferrals user_id={this.props.user_id} />}
                        {myteamSubTab === "portfolio" && <UserPortfolio user_id={this.props.user_id} />}
                    </div>
                );

            case 9:
                return (
                    <div>
                        {this.renderSubTabBar(
                            [{ key: "documents", label: "📄 Documents" }, { key: "bank", label: "🏦 Bank Details" }],
                            kycSubTab,
                            (v) => this.setState({ kycSubTab: v })
                        )}
                        {kycSubTab === "documents" && <UserDocuments user_id={this.props.user_id} applicationData={this.props.application_data} />}
                        {kycSubTab === "bank"      && <UserBankDetails user_id={this.props.user_id} />}
                    </div>
                );

            default:
                return null;
        }
    }

    renderComingSoon(title, description) {
        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "60px 20px", textAlign: "center" }}>
                <div style={{ fontSize: 48, marginBottom: 14 }}>🔜</div>
                <div style={{ fontSize: 16, fontWeight: 600, color: "#555", marginBottom: 8 }}>{title}</div>
                <p style={{ fontSize: 14, color: "#999", margin: 0 }}>{description}</p>
            </div>
        );
    }

    render() {
        let { selectedProfileTab, isMobile } = this.state;
        const allTabs = MENU_SECTIONS.flatMap(s => s.items);

        return (
            <Modal
                isOpen={true}
                toggle={() => this.props.toggle()}
                style={isMobile
                    ? { maxWidth: "100%", width: "100%", margin: 0, padding: 0 }
                    : { maxWidth: "1080px", width: "90vw", margin: "4vh auto" }
                }
            >
                <ModalHeader toggle={() => this.props.toggle()} style={{ borderBottom: "1px solid #eee", padding: "12px 16px" }}>
                    <h5 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>Partner Details</h5>
                </ModalHeader>
                <ModalBody className="p-0" style={{ display: "flex", flexDirection: isMobile ? "column" : "row", height: isMobile ? "92vh" : "88vh", overflow: "hidden" }}>

                    {isMobile ? (
                        /* Mobile: horizontal scrollable tab strip */
                        <div style={S.mobileTabBar}>
                            {allTabs.map((item) => (
                                <button
                                    key={item.tab}
                                    style={{ ...S.mobileTab, ...(selectedProfileTab === item.tab ? S.mobileTabActive : {}) }}
                                    onClick={() => this.switchTab(item.tab)}
                                >
                                    {item.label}
                                </button>
                            ))}
                        </div>
                    ) : (
                        /* Desktop: vertical sidebar */
                        <div style={S.sidebar}>
                            {MENU_SECTIONS.map((section) => (
                                <div key={section.label}>
                                    <div style={S.sectionLabel}>{section.label}</div>
                                    {section.items.map((item) => (
                                        <div
                                            key={item.tab}
                                            style={{ ...S.sidebarItem, ...(selectedProfileTab === item.tab ? S.sidebarItemActive : {}) }}
                                            onClick={() => this.switchTab(item.tab)}
                                        >
                                            {item.label}
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Content Area */}
                    <div style={{ ...S.contentArea, padding: isMobile ? "16px 14px" : "26px 28px" }}>
                        {this.renderContent()}
                    </div>

                </ModalBody>
            </Modal>
        );
    }
}

const S = {
    /* ── layout ─────────────────────────────────────────── */
    mobileTabBar: {
        display: "flex",
        overflowX: "auto",
        borderBottom: "1px solid #e8e8e8",
        background: "#fafafa",
        flexShrink: 0,
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        padding: "0 8px",
    },
    mobileTab: {
        flexShrink: 0,
        padding: "12px 14px",
        fontSize: 13,
        fontWeight: 500,
        color: "#666",
        background: "none",
        border: "none",
        borderBottom: "2px solid transparent",
        cursor: "pointer",
        whiteSpace: "nowrap",
        outline: "none",
    },
    mobileTabActive: {
        color: "#c0392b",
        borderBottomColor: "#c0392b",
        fontWeight: 600,
    },
    sidebar: {
        width: 210,
        minWidth: 210,
        borderRight: "1px solid #e8e8e8",
        overflowY: "auto",
        padding: "12px 0",
        background: "#fafafa",
    },
    sectionLabel: {
        padding: "10px 20px 4px",
        fontSize: 10,
        fontWeight: 700,
        color: "#bbb",
        textTransform: "uppercase",
        letterSpacing: "0.6px",
    },
    sidebarItem: {
        padding: "11px 22px",
        fontSize: 13.5,
        color: "#444",
        cursor: "pointer",
        borderLeft: "3px solid transparent",
        transition: "background 0.12s, color 0.12s",
    },
    sidebarItemActive: {
        background: "#fff",
        color: "#c0392b",
        borderLeftColor: "#c0392b",
        fontWeight: 500,
    },
    contentArea: {
        flex: 1,
        overflowY: "auto",
        padding: "26px 28px",
    },
    /* ── sub-tabs ────────────────────────────────────────── */
    subTabBar: {
        display: "flex",
        borderBottom: "2px solid #f0f0f0",
        marginBottom: 22,
    },
    subTabBtn: {
        padding: "10px 20px",
        background: "none",
        border: "none",
        fontSize: 13,
        fontWeight: 500,
        color: "#888",
        cursor: "pointer",
        borderBottom: "2px solid transparent",
        marginBottom: -2,
        outline: "none",
        transition: "color 0.15s",
    },
    subTabBtnActive: {
        color: "#c0392b",
        borderBottomColor: "#c0392b",
        fontWeight: 600,
    },
    /* ── identity card ───────────────────────────────────── */
    identityCard: {
        border: "1px solid #e8e8e8",
        borderRadius: 14,
        padding: "16px 16px",
        marginBottom: 20,
        background: "#fff",
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "wrap",
        gap: 16,
    },
    avatar: {
        width: 64,
        height: 64,
        minWidth: 64,
        borderRadius: "50%",
        background: "#e0e4ea",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 22,
        fontWeight: 700,
        color: "#555",
    },
    partnerName: {
        fontSize: 20,
        fontWeight: 700,
        color: "#1a1a1a",
        marginBottom: 6,
    },
    metaRow: {
        display: "flex",
        alignItems: "center",
        gap: 16,
        flexWrap: "wrap",
        marginBottom: 4,
    },
    metaItem: {
        fontSize: 13,
        color: "#666",
        display: "flex",
        alignItems: "center",
        gap: 5,
    },
    footerRow: {
        display: "flex",
        gap: 24,
        flexWrap: "wrap",
        marginTop: 12,
        paddingTop: 12,
        borderTop: "1px solid #f0f0f0",
    },
    footerItem: { display: "flex", flexDirection: "column" },
    footerLabel: {
        fontSize: 11,
        color: "#aaa",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.3px",
        marginBottom: 2,
    },
    footerValue: { fontSize: 13, color: "#444", fontWeight: 500 },
    pill: {
        borderRadius: 999,
        padding: "4px 14px",
        fontSize: 12,
        fontWeight: 700,
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
    },
    /* ── overview sections ───────────────────────────────── */
    ovSection: { marginBottom: 24 },
    ovSectionTitle: {
        fontSize: 13,
        fontWeight: 700,
        color: "#888",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        marginBottom: 12,
        display: "flex",
        alignItems: "center",
        gap: 8,
    },
    ovSectionDivider: {
        flex: 1,
        height: 1,
        background: "#f0f0f0",
        display: "inline-block",
    },
    /* ── KPI row ─────────────────────────────────────────── */
    kpiRow: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
        gap: 12,
    },
    kpiCard: {
        border: "1px solid #e8e8e8",
        borderLeft: "3px solid #e0e0e0",
        borderRadius: 10,
        padding: "14px 16px",
        background: "#fff",
    },
    kpiLabel: {
        display: "block",
        fontSize: 11,
        color: "#999",
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.3px",
        marginBottom: 6,
    },
    kpiValue: {
        fontSize: 20,
        fontWeight: 800,
        color: "#1a1a1a",
    },
    /* ── trust grid ──────────────────────────────────────── */
    trustGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 10,
    },
    trustRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 14px",
        border: "1px solid #f0f0f0",
        borderRadius: 8,
        background: "#fafafa",
        fontSize: 13,
    },
    trustLabel: { color: "#555", fontWeight: 500 },
    trustValue: { fontWeight: 600 },
    /* ── activity feed ───────────────────────────────────── */
    activityFeed: { display: "flex", flexDirection: "column", gap: 8 },
    activityItem: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 14px",
        border: "1px solid #f0f0f0",
        borderRadius: 8,
        background: "#fafafa",
    },
    activityIcon: { fontSize: 16, width: 28, textAlign: "center", flexShrink: 0 },
    activityBody: { flex: 1 },
    activityTitle: { fontSize: 13, color: "#1a1a1a", fontWeight: 500 },
    activitySub:   { fontSize: 11, color: "#999", marginTop: 1 },
    activityTime:  { fontSize: 11, color: "#bbb", whiteSpace: "nowrap", flexShrink: 0 },
};

export default PartnerDetail;
